import React from "react";

const AnalyticsIcon = () => (
  <svg className="analytics-icon" x="0px" y="0px" viewBox="0 0 23.239 23.731">
    <g
      id="_124473821582960204"
      data-name="124473821582960204"
      transform="translate(-3.596 -2.318)"
    >
      <path
        id="Path_153"
        data-name="Path 153"
        d="M37.645,2.318a11.369,11.369,0,0,0-6.518,2.046.13.13,0,0,0-.026.187h0l6.9,8.3a.13.13,0,0,0,.1.047H48.9a.125.125,0,0,0,.093-.042.128.128,0,0,0,.034-.1A11.493,11.493,0,0,0,37.645,2.318Zm1.112,9.064L33.315,4.836a9.843,9.843,0,0,1,4.33-1,9.979,9.979,0,0,1,9.616,7.545Z"
        transform="translate(-22.192)"
        stroke="#656588"
        strokeWidth="0.1"
      />
      <path
        id="Path_154"
        data-name="Path 154"
        d="M26.407,32.975A11.427,11.427,0,1,1,6.99,23.865a.123.123,0,0,1,.087-.038h.008a.129.129,0,0,1,.093.046l7.45,8.964H26.28a.127.127,0,0,1,.095.042A.125.125,0,0,1,26.407,32.975Z"
        transform="translate(0 -17.371)"
        stroke="#656588"
        strokeWidth="0.1"
      />
    </g>
  </svg>
);

export default AnalyticsIcon;
